import { useEffect, useRef } from "react"
import { Howl } from "howler"
import { SOUNDS } from "../../constants/sounds"
import { useVolume } from "../../contexts/VolumeContext"
import styles from "./SkillCircle.module.css"
import Tooltip from "./Tooltip"

type Props = {
  name: string
  src: string
  size?: number
  hoverRate?: number
}

export default function SkillCircle({ name, src, size = 56, hoverRate = 1.0 }: Props) {
  const { volume: globalVolume } = useVolume()
  const hoverSoundRef = useRef<Howl | null>(null)

  useEffect(() => {
    hoverSoundRef.current = new Howl({
      src: [SOUNDS.HOVER],
      volume: 0.3,
      rate: hoverRate
    })

    return () => {
      hoverSoundRef.current?.unload()
    }
  }, [hoverRate])

  useEffect(() => {
    if (hoverSoundRef.current) {
      const finalVolume = (0.3 * globalVolume) / 100
      hoverSoundRef.current.volume(finalVolume)
    }
  }, [globalVolume])

  const handleMouseEnter = () => {
    hoverSoundRef.current?.play()
  }

  return (
    <Tooltip text={name}>
      <div 
        className={styles.circle} 
        style={{ width: size, height: size }} 
        aria-label={name}
        onMouseEnter={handleMouseEnter}
      >
        <img className={styles.img} src={src} alt={name} />
      </div>
    </Tooltip>
  )
}